"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _Header = _interopRequireDefault(require("../Navigation/Header"));

var _Footer = _interopRequireDefault(require("../Footer/Footer"));

var _CollectionHero = _interopRequireDefault(require("../Hero/CollectionHero"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 0px 24px;\n  @media (max-width: 640px) {\n    padding: 0px 6px;\n  }\n\n  > p {\n    width: 100%;\n    max-width: 700px;\n    font-size: 18px;\n    margin-bottom: 1.5em;\n    line-height: 1.8;\n\n    &.transition {\n      margin: 80px auto;\n    }\n\n    &.small {\n      font-size: 14px;\n    }\n  }\n\n  & > p,\n  & > h1,\n  & > h2,\n  & > h3,\n  & > h4,\n  & > h5,\n  & > h6 {\n    margin: auto;\n    @media (max-width: 640px) {\n      width: 90%;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultStyles = (0, _emotion.css)(_templateObject());

var PageLayout = function PageLayout(_ref) {
  var header = _ref.header,
      heroTitle = _ref.heroTitle,
      heroSubtitle = _ref.heroSubtitle,
      mainProjectColor = _ref.mainProjectColor,
      teamTitle = _ref.teamTitle,
      overlay = _ref.overlay,
      children = _ref.children,
      attribution = _ref.attribution;
  return _react["default"].createElement("div", null, header && _react["default"].createElement(_Header["default"], {
    title: "Civic homepage",
    mainProjectColor: mainProjectColor,
    overlay: overlay || false
  }), heroTitle && _react["default"].createElement(_CollectionHero["default"], {
    teamTitle: teamTitle,
    heroTitle: heroTitle,
    heroSubtitle: heroSubtitle,
    mainProjectColor: mainProjectColor
  }), _react["default"].createElement("div", {
    className: defaultStyles
  }, children), _react["default"].createElement(_Footer["default"], {
    attribution: attribution
  }));
};

PageLayout.displayName = "PageLayout";
PageLayout.propTypes = {
  header: _propTypes["default"].bool,
  overlay: _propTypes["default"].bool,
  teamTitle: _propTypes["default"].string,
  heroTitle: _propTypes["default"].string,
  heroSubtitle: _propTypes["default"].string,
  mainProjectColor: _propTypes["default"].string,
  children: _propTypes["default"].node,
  attribution: _propTypes["default"].node
};
PageLayout.defaultProps = {
  header: true
};
var _default = PageLayout;
exports["default"] = _default;